import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CKEDITOR_CONFIG, CKEDITOR_LOAD_ERROR_MESSAGE_KEY, CKEDITOR_SCRIPT_ID, CKEDITOR_SCRIPT_PATH } from '../../../utils/Constants';
// import SendMedia from './sentmedia';

let ckeditorLoadPromise = null;

const loadCkeditor = () => {
  if (window.CKEDITOR) {
    return Promise.resolve(window.CKEDITOR);
  }

  if (ckeditorLoadPromise) {
    return ckeditorLoadPromise;
  }

  ckeditorLoadPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(CKEDITOR_SCRIPT_ID);

    if (existingScript) {
      if (window.CKEDITOR) {
        resolve(window.CKEDITOR);
        return;
      }

      existingScript.addEventListener("load", () => resolve(window.CKEDITOR), { once: true });
      existingScript.addEventListener("error", reject, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.id = CKEDITOR_SCRIPT_ID;
    script.src = CKEDITOR_SCRIPT_PATH;
    script.async = true;
    script.onload = () => resolve(window.CKEDITOR);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return ckeditorLoadPromise;
};

export default function CustomCkeditor(props) {
  const { t } = useTranslation();
  const {
    onChange = () => { },
    setFieldValue = () => { },
    config = {},
    fieldname
  } = props;
  const editorId = props.id || fieldname;
  const CKEDITOR_CONFIG_LOCAL = {
    ...CKEDITOR_CONFIG,
  };
  const defaultConfigs = {
    // extraPlugins: 'CustomButton',
    // extraPlugins: 'MediaButton',
  };
  function cleanupEditor(editor) {
    // window.CKEDITOR = {...window.CKEDITOR_BACKUP};
    editor.destroy();
  };
  function handleMediaSelectionSubmit(media = []) {
    const editor = window.CKEDITOR.instances[editorId];
    let editorContent = editor.getData() || "";
    media.forEach((file) => {
      const fileExtension = file.split('.').pop().toLowerCase();
      const isImage = ['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension);

      if (isImage) {
        editorContent += `<p><img src="${file}" alt="Selected Image"></p>`;
      } else {
        const fileName = file.split('/').pop();
        editorContent += `<p><a href="${file}" target="_blank">${fileName}</a></p>`;
      }
    });
    editor.setData(editorContent);
  };
  /** states >>>> */
  const [openMedia, setOpenMedia] = useState(false);
  const [editorLoadError, setEditorLoadError] = useState("");
  /** states <<<< */
  function addMediaButton(editor) {
    let alreadyExist = window.CKEDITOR.plugins.get('MediaButton');
    if (!alreadyExist) {
      window.CKEDITOR.plugins.add('MediaButton', {
        icons: 'mediaButton'
      });
    }
    editor.addCommand('insertMedia', {
      exec: function () {
        setOpenMedia(true);
      }
    });
    editor.ui.addButton('MediaButton', {
      label: 'Select Media',
      command: 'insertMedia',
      toolbar: 'insert',
      icon: '/assets/ckeditor/images/media-icon.png'
    });
  };
  useEffect(() => {
    let editor = null;
    let isMounted = true;

    loadCkeditor().then(() => {
      if (!isMounted) {
        return;
      }

      setEditorLoadError("");
      /** Adding custom button for media selection */
      editor = window.CKEDITOR.replace(editorId, { ...CKEDITOR_CONFIG_LOCAL, ...config, ...defaultConfigs });
      /** Listening for onchange event */
      addMediaButton(editor);
      editor.on('change', function (event) {
        onChange(event, editor);
        setFieldValue(editorId, editor.getData());
      });
    }).catch((error) => {
      console.error("Error loading CKEditor", error);
      if (isMounted) {
        setEditorLoadError(CKEDITOR_LOAD_ERROR_MESSAGE_KEY);
      }
    });

    return () => {
      isMounted = false;
      if (editor) {
        cleanupEditor(editor);
      }
    };
  }, []);
  return (
    <div>
      <textarea id={editorId} defaultValue={props?.data ? props?.data : props?.value}></textarea>
      {editorLoadError ? <div className="text-danger mt-2">{t(editorLoadError)}</div> : null}
      {openMedia ?
        <>
          {/* <SendMedia
            setOpen={setOpenMedia}
            onSubmit={handleMediaSelectionSubmit}
            successButtonText="Insert"
          /> */}
        </> : null}
    </div>
  )
}
